import type { ReactElement } from 'react'
import { NavLink } from 'react-router-dom'
import { cn } from '../../utils/cn'

const icons: Record<string, ReactElement> = {
  dashboard: (
    <path d="M104,40H56A16,16,0,0,0,40,56v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,104,40Zm0,64H56V56h48v48Zm96-64H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm0,64H152V56h48v48ZM104,136H56a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,104,136Zm0,64H56V152h48v48Zm96-64H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,200,136Zm0,64H152V152h48v48Z" />
  ),
  apps: (
    <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM40,56H216V88H40Zm176,144H40V104H216v96ZM72,72a8,8,0,1,1-8-8A8,8,0,0,1,72,72Zm32,0a8,8,0,1,1-8-8A8,8,0,0,1,104,72Z" />
  ),
  invoices: (
    <path d="M96,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H104A8,8,0,0,1,96,64Zm120,56H104a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,64H104a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM60,52A12,12,0,1,0,72,64,12,12,0,0,0,60,52Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,60,116Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,60,180Z" />
  ),
  support: (
    <path d="M128,24A104,104,0,0,0,36.18,176.88L24.83,210.93a13.28,13.28,0,0,0,16.24,16.24l34.05-11.35A104,104,0,1,0,128,24Zm0,192a87.87,87.87,0,0,1-44.06-11.81,8,8,0,0,0-6.68-.61L40,215.83,51.42,178.74a8,8,0,0,0-.61-6.68A88,88,0,1,1,128,216Z" />
  ),
  account: (
    <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24ZM74.08,197.5a64,64,0,0,1,107.84,0,87.83,87.83,0,0,1-107.84,0ZM96,120a32,32,0,1,1,32,32A32,32,0,0,1,96,120Zm97.76,66.41a79.66,79.66,0,0,0-36.06-28.75,48,48,0,1,0-59.4,0,79.66,79.66,0,0,0-36.06,28.75,88,88,0,1,1,131.52,0Z" />
  ),
}

const navItems = [
  { title: 'Übersicht', path: '/customer', icon: 'dashboard', end: true },
  { title: 'Meine Apps', path: '/customer/apps', icon: 'apps' },
  { title: 'Rechnungen', path: '/customer/invoices', icon: 'invoices' },
  { title: 'Support', path: '/customer/support', icon: 'support' },
  { title: 'Konto', path: '/customer/account', icon: 'account' },
]

export default function CustomerNavigation({ collapsed }: { collapsed: boolean }) {
  return (
    <nav style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {navItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          end={item.end}
          title={collapsed ? item.title : undefined}
          className={({ isActive }) => cn('wc-sidenav-link', isActive && 'active')}
        >
          <svg width="16" height="16" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" style={{ flexShrink: 0 }}>
            {icons[item.icon]}
          </svg>
          {!collapsed && <span>{item.title}</span>}
        </NavLink>
      ))}
    </nav>
  )
}
